/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // remove any gift products that are no longer free before rendering
    await removeGiftItems();

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#headerIconsCartCount").textContent = `${cart.item_count}`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartRecommendations").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartRecommendations").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You Get Free Shipping";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade To A Subscription For Free Shipping";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You Get Free Shipping";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend ${price(freeShippingThreshold - cart.total_price)} more for Free Shipping`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // keep track of savings
    let cartSavings = 0;

    // grab subscription id of any items, try to match with upsells
    let subId = null;

    // append cart
    cart.items.forEach(function (item) {
        // save supplement data

        const supplementData = cartData[item.key];

        // determine if item has properties
        const hasProperties = item?.properties && Object.keys(item.properties).length > 0;

        // determine if it is a gift
        const isGift = item?.properties?._gift && item.final_line_price === 0;

        // alternate product title
        function productTitleHTML() {
            return supplementData?.short_title ? supplementData.short_title : item.product_title;
        }

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null || isGift) {
                return "";
            }

            const variantLabel = supplementData?.cart_variant_label ? supplementData.cart_variant_label + ": " : "";

            return `<div class="miniCartBodyItemVariant">${variantLabel}${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties || isGift) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for hidden properties
                if (key[0] === "_") continue;
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                subId = item.selling_plan_allocation.selling_plan.id || null;
                return `<div class="miniCartBodyItemSellingPlan">Subscribe & Save: ${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return `<div class="miniCartBodyItemSellingPlan">One Time Purchase</div>`;
        }

        // price HTML
        function priceHTML() {

            if (isGift) {
                // update the cart savings to include free gifts full price
                cartSavings += item.total_discount;
                return `<span>FREE</span> <s>${price(item.final_line_price)}</s>`
            }

            let HTML = `<span>${price(item.final_line_price)}</span>`;

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (supplementData?.compare_at_price) {
                comparePrices.push(supplementData.compare_at_price * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    HTML += `
                        <s>${price(greatestComparePrice)}</s>
                    `;
                }

                // update the cart savings to include subscriptions
                cartSavings += greatestComparePrice - item.final_line_price;
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation) {
                return `
                    <button 
                        class="miniCartBodyItemRemoveSubscription button "
                        data-key="${item.key}"
                        data-quantity="${item.quantity}" 
                    >
                    Switch to One Time Purchase
                    </button>
                `;
            }

            let html = "";
            if (!supplementData) {
                return html;
            }
            //loop through all plans for the product, and create a button for it
            for (let plan of supplementData) {
                // check if selling plan exists
                if (!plan["selling_plan_id"]) {
                    return "";
                }

                let orderClass = ""
                if (plan["selling_plan_id"] === 2555871367) {
                    orderClass = "first"
                } else if (plan["selling_plan_id"] === 2895806599) {
                    orderClass = "second"
                }

                html += `
                    <button 
                        class="miniCartBodyItemUpgrade button ${orderClass}"
                        data-key="${item.key}"
                        data-quantity="${item.quantity}" 
                        data-plan="${plan["selling_plan_id"]}"
                    >
                    ${plan["selling_plan_name"]}
                    </button>
                `
            }

            // return HTML
            return `
                <div class="miniCartBodyItemUpgradeWrapper">
                    <div class="miniCartBodyItemUpgradeWrapperTitle">Subscribe & Save</div>
                    <div class="miniCartBodyItemUpgradeWrapperInner">
                        ${html}
                    </div>
                </div>
            `;
        }

        // add quantity update unless it is a gift
        function quantityHTML() {

            if (isGift) return ``;

            return `
            <div class="miniCartBodyItemQuantity">
                <button class="miniCartBodyItemQuantityMinus" type="button" aria-label="less quantity">
                    <svg aria-hidden="true" width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.396 1.044C0.276 1.044 0.18 1.008 0.108 0.936C0.036 0.864 0 0.768 0 0.648V0.396C0 0.276 0.036 0.18 0.108 0.108C0.18 0.036 0.276 0 0.396 0H10.746C10.866 0 10.962 0.036 11.034 0.108C11.106 0.18 11.142 0.276 11.142 0.396V0.648C11.142 0.768 11.106 0.864 11.034 0.936C10.962 1.008 10.866 1.044 10.746 1.044H0.396Z" fill="#0F2B5C"/></svg>
                </button>
                <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                <button class="miniCartBodyItemQuantityPlus" type="button" aria-label="more quantity">
                    <svg aria-hidden="true" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.698 9.612C4.578 9.612 4.482 9.576 4.41 9.504C4.338 9.432 4.302 9.336 4.302 9.216V5.274H0.396C0.276 5.274 0.18 5.238 0.108 5.166C0.036 5.094 0 4.998 0 4.878V4.626C0 4.506 0.036 4.41 0.108 4.338C0.18 4.266 0.276 4.23 0.396 4.23H4.302V0.396C4.302 0.276 4.338 0.18 4.41 0.108C4.482 0.0359999 4.578 0 4.698 0H4.968C5.088 0 5.184 0.0359999 5.256 0.108C5.328 0.18 5.364 0.276 5.364 0.396V4.23H9.288C9.408 4.23 9.504 4.266 9.576 4.338C9.648 4.41 9.684 4.506 9.684 4.626V4.878C9.684 4.998 9.648 5.094 9.576 5.166C9.504 5.238 9.408 5.274 9.288 5.274H5.364V9.216C5.364 9.336 5.328 9.432 5.256 9.504C5.184 9.576 5.088 9.612 4.968 9.612H4.698Z" fill="#0F2B5C"/></svg>
                </button>
            </div>
            `
        }

        // add remove button unless it is a gift
        function removeHTML() {

            if (isGift) return ``;

            return `
             <button class="miniCartBodyItemRemove" type="button" aria-label="remove item">
                <svg aria-hidden="true" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_384_1400)">
                        <path d="M23.1484 5.92495H1.85469C1.33594 5.92495 0.914062 5.50308 0.914062 4.98433C0.914062 4.46558 1.33594 4.0437 1.85469 4.0437H23.1484C23.6672 4.0437 24.0891 4.46558 24.0891 4.98433C24.0891 5.50308 23.6672 5.92495 23.1484 5.92495Z" fill="#0038B8"/>
                        <path d="M12.9834 24.7126H12.0146C8.55211 24.7126 6.64586 24.7126 5.28961 23.4469C3.93648 22.1813 3.80836 20.2782 3.57711 16.8219L3.00211 8.1813C2.96773 7.66255 3.35836 7.21568 3.87711 7.1813C4.39586 7.14693 4.84273 7.53755 4.87711 8.0563L5.45211 16.6969C5.65836 19.7719 5.76148 21.3157 6.57398 22.0751C7.38648 22.8344 8.93336 22.8344 12.0146 22.8344H12.9834C16.0646 22.8344 17.6115 22.8344 18.424 22.0751C19.2365 21.3157 19.3396 19.7719 19.5459 16.6969L20.1209 8.0563C20.1552 7.53755 20.6052 7.14693 21.1209 7.1813C21.6396 7.21568 22.0302 7.66255 21.9959 8.1813L21.4209 16.8219C21.1896 20.2782 21.0646 22.1813 19.7084 23.4469C18.3552 24.7126 16.4459 24.7126 12.9834 24.7126Z" fill="#0038B8"/>
                        <path d="M9.99404 18.4501C9.51592 18.4501 9.10967 18.0876 9.05967 17.6032L8.43467 11.3407C8.38154 10.8251 8.75967 10.3626 9.27529 10.3126C9.79092 10.2595 10.2534 10.6376 10.3034 11.1532L10.9284 17.4157C10.9815 17.9313 10.6034 18.3938 10.0878 18.4438C10.0565 18.447 10.0253 18.4501 9.99404 18.4501Z" fill="#0038B8"/>
                        <path d="M15.0058 18.4501C14.9745 18.4501 14.9433 18.4501 14.912 18.4438C14.3964 18.3907 14.0183 17.9313 14.0714 17.4157L14.6964 11.1532C14.7495 10.6376 15.2089 10.2595 15.7245 10.3126C16.2401 10.3657 16.6183 10.8251 16.5651 11.3407L15.9401 17.6032C15.8901 18.0876 15.4839 18.4501 15.0058 18.4501Z" fill="#0038B8"/>
                        <path d="M19.3922 5.9249C19.3109 5.9249 19.2703 5.9249 19.2328 5.9249C18.5359 5.90615 17.8703 5.68428 17.3047 5.2749C16.7391 4.86865 16.3172 4.30615 16.0797 3.65303C16.0672 3.61865 16.0547 3.57803 16.0266 3.4999L15.9047 3.13428C15.8234 2.89365 15.7734 2.7374 15.7391 2.67178C15.6016 2.40928 15.3453 2.2249 15.0547 2.17803C14.9797 2.16553 14.8141 2.16553 14.5641 2.16553H10.4453C10.1922 2.16553 10.0266 2.16553 9.95469 2.17803C9.66094 2.2249 9.40781 2.40928 9.27031 2.67178C9.23594 2.7374 9.18281 2.89678 9.10469 3.13428L8.98281 3.4999C8.95781 3.57803 8.94219 3.61553 8.92969 3.65303C8.69219 4.30615 8.27031 4.86865 7.70469 5.2749C7.13906 5.68115 6.47344 5.90615 5.77656 5.9249C5.73906 5.9249 5.69844 5.9249 5.61719 5.9249V4.04678C5.67344 4.04678 5.70469 4.04678 5.72969 4.04678C6.37969 4.03115 6.94219 3.6249 7.16094 3.01553C7.17031 2.99053 7.17969 2.9624 7.19844 2.90928L7.32031 2.54365C7.43594 2.19678 7.49844 2.00615 7.60156 1.80615C8.01094 1.01865 8.77969 0.465527 9.65781 0.324902C9.87969 0.290527 10.0797 0.290527 10.4453 0.290527H14.5641C14.9297 0.290527 15.1297 0.290527 15.3516 0.324902C16.2297 0.465527 16.9953 1.01865 17.4078 1.80615C17.5109 2.00303 17.5734 2.19365 17.6891 2.54053L17.8109 2.90928C17.8297 2.96553 17.8391 2.99053 17.8484 3.01553C18.0703 3.6249 18.6328 4.03115 19.2797 4.04678C19.3047 4.04678 19.3359 4.04678 19.3922 4.04678V5.9249Z" fill="#0038B8"/>
                    </g>
                    <defs><clipPath id="clip0_384_1400"><rect width="25" height="25" fill="white"/></clipPath></defs>
                </svg>
             </button>
            `
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem ${isGift ? "gift" : ""}" data-key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div class="miniCartBodyItemInner">
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${productTitleHTML()}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                        ${quantityHTML()}
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                        ${removeHTML()}
                    </div>
                </div>
                <div></div>
                ${upgradeHTML()}
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {

        // if a gift, no need for listener
        if (element.classList.contains('gift')) return;

        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelectorAll(".miniCartBodyItemUpgrade")?.forEach((upgrade) => {
            upgrade.addEventListener("click", async function () {
                const key = upgrade.dataset.key;
                const quantity = parseInt(upgrade.dataset.quantity);
                const sellingPlanID = parseInt(upgrade.dataset.plan);

                // start loading animation
                document.querySelector("#miniCartContent").classList.add("loading");

                // add selling plan
                cart = await changeCart({
                    id: key,
                    quantity: quantity,
                    selling_plan: sellingPlanID
                });

                await openCart(true);

                // remove loading animation
                this.classList.remove("loading");
            });
        });

        // Remove subscription button listener
        element.querySelector(".miniCartBodyItemRemoveSubscription")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            //remove selling plan
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: null
            });

            await openCart(true);

            // remove loading animation
            this.classList.remove("loading");
        });
    });


    // update the recommended
    await recommendedProducts(subId);

    // update the savings in the footer
    document.querySelector('#miniCartFooterSub').textContent = `Subtotal: ${price(cart.items_subtotal_price)}`;
    // update the subtotal
    document.querySelector('#miniCartFooterSavings').textContent = cartSavings > 0 ? `You Saved ${price(cartSavings)}` : "";

}

/**************
 Gift removal
 ***************/

// remove gift products from the cart if they are no longer free
async function removeGiftItems() {
    // exit if no gift removal list is configured
    const giftProducts = cartSettings.gifts_removal;
    if (!giftProducts || giftProducts.length === 0) {
        return;
    }

    // build a set of gift product IDs for fast lookup
    const giftProductIDs = new Set(giftProducts.map(product => product.id));

    // find cart items that are in the gift list but not free
    const itemsToRemove = cart.items.filter(item => giftProductIDs.has(item.product_id) && item.final_line_price > 0);

    // exit if there is nothing to remove
    if (itemsToRemove.length === 0) {
        return;
    }

    // zero out each non-free gift item
    const updates = {};
    itemsToRemove.forEach(item => {
        updates[item.key] = 0;
    });

    // update cart and refresh the global cart state
    cart = await updateCart({updates});
}

/*******************
 Recommended products
 ********************/

async function recommendedProducts(subId) {
    // NOTE FROM GRANT
    // Changed this endpoint to pull from a collection, that way the client can control what products
    // appear in the upsells area.
    // Fetch products in the recommendation collection
    const response = await fetch(`/collections/product-recommendations/products.json`)
        .then(r => r.json());

    const cartProductIDs = cart.items.map(el => el.product_id);

    // exclude products already in the cart
    const products = response.products.filter(product => !cartProductIDs.includes(product.id))

    // if no products
    if (products.length === 0) {
        document.querySelector('#miniCartRecommendations').classList.remove('active');
        return;
    }

    // build slides
    let html = "";

    // render every recommendation in collection order
    products.forEach(product => {
        const isSingleVariant = product.variants.length === 1;

        // skip single-variant products that are unavailable or locked to a selling plan
        if (isSingleVariant && (!product.variants[0].available || product.variants[0].requires_selling_plan)) {
            return;
        }

        // build variant option buttons, filtering out unavailable and selling-plan-only variants
        // add another or statement to check and see if that option (variant) is already in the cart if that is desired logic --Grant 
        let variantsHTML = "";
        if (!isSingleVariant) {
            product.variants.forEach(variant => {
                if (variant.requires_selling_plan) return;
                if (!variant.available) {
                    variantsHTML += `<button disabled class="miniCartRecommendationsSwiperItemVariantsItemDisabled button" type="button" data-id="${variant.id}">${variant.title}</button>`;
                } else {
                    variantsHTML += `<button class="miniCartRecommendationsSwiperItemVariantsItem button" type="button" data-id="${variant.id}">${variant.title}</button>`;
                }
            });
            // skip the product if no purchasable variants remain
            if (!variantsHTML) return;
        }

        // check if any selling plan on this product matches the subscribed plan in the cart
        let subscribeHTML = "";
        let matchingPlanId = "";
        //upsells
        if (subId && product.selling_plan_groups && product.selling_plan_groups.length > 0) {
            product.selling_plan_groups.forEach(group => {
                if (matchingPlanId) return;
                group.selling_plans.forEach(plan => {
                    if (plan.id !== subId) return;
                    matchingPlanId = plan.id;
                    let subscribeText = plan.name;
                    if (plan.price_adjustments && plan.price_adjustments.length > 0 && plan.price_adjustments[0].value_type === "percentage") {
                        subscribeText = `Subscribe & Save <strong class="miniCartRecommendationsSwiperItemSubscribeTextDiscount">${plan.price_adjustments[0].value}%</strong>`;
                    }
                    subscribeHTML = `
                        <div class="miniCartRecommendationsSwiperItemSubscribe active">
                            <span class="miniCartRecommendationsSwiperItemSubscribeText">${subscribeText}</span>
                            <label class="miniCartRecommendationsSwiperItemSubscribeLabel">
                                <input class="miniCartRecommendationsSwiperItemSubscribeCheck" type="checkbox" aria-label="add subscription">
                                <span class="miniCartRecommendationsSwiperItemSubscribeToggle"></span>
                            </label>
                        </div>
                    `;
                });
            });
        }

        // single-variant Add button carries the variant ID directly; multi-variant Add button reveals choices
        let addDataId = "";
        if (isSingleVariant) {
            addDataId = product.variants[0].id;
        }

        html += `
            <div class="miniCartRecommendationsSwiperItem swiper-slide"
                 data-single-variant="${isSingleVariant}"
                 data-sub-plan-id="${matchingPlanId}">
                <div class="miniCartRecommendationsSwiperItemTop">
                    <img class="miniCartRecommendationsSwiperItemImage" src="${product.featured_image ?? product.images[0].src}&width=200" alt="${product.title}">
                    <div class="miniCartRecommendationsSwiperItemBody">
                        <span class="miniCartRecommendationsSwiperItemBodyTitle active">${product.title}</span>
                        <button class="miniCartRecommendationsSwiperItemAdd button active" type="button"
                                data-id="${addDataId}"
                                aria-label="add ${product.title} to cart">Add</button>
                        <div class="miniCartRecommendationsSwiperItemVariants">
                            ${variantsHTML}
                        </div>
                    </div>
                </div>
                ${subscribeHTML}
            </div>
        `;
    });

    // replace swiper slides and update swiper
    document.querySelector('#miniCartRecommendationsSwiperWrapper').innerHTML = html;
    recSwiper.update();
}

// recommended swiper
const recSwiper = new Swiper(document.querySelector("#miniCartRecommendationsSwiper"), {
    slidesPerView: 1,
    navigation: {
        nextEl: document.querySelector(".miniCartRecommendationsTopNavItem.next"),
        prevEl: document.querySelector(".miniCartRecommendationsTopNavItem.prev"),
    }
})

// delegated click handler for all recommendation slide interactions
document.querySelector('#miniCartRecommendationsSwiperWrapper').addEventListener('click', async function (e) {
    // handle Add button — single variant adds immediately, multi-variant reveals choices
    const addBtn = e.target.closest('.miniCartRecommendationsSwiperItemAdd');
    if (addBtn) {
        const item = addBtn.closest('.miniCartRecommendationsSwiperItem');
        if (item.dataset.singleVariant === 'true') {
            await addRecommendedItem(item, addBtn.dataset.id);
        } else {
            addBtn.classList.remove('active');
            item.querySelector('.miniCartRecommendationsSwiperItemBodyTitle').classList.remove('active');
            item.querySelector('.miniCartRecommendationsSwiperItemVariants').classList.add('active');
        }
        return;
    }

    // handle variant button — adds that specific variant to the cart
    const variantBtn = e.target.closest('.miniCartRecommendationsSwiperItemVariantsItem');
    if (variantBtn) {
        const item = variantBtn.closest('.miniCartRecommendationsSwiperItem');
        await addRecommendedItem(item, variantBtn.dataset.id);
    }
});

// add a recommended product to the cart, optionally as a subscription if the toggle is on
async function addRecommendedItem(item, variantId) {
    document.querySelector("#miniCartContent").classList.add("loading");

    const formData = {
        items: [{
            quantity: 1,
            id: parseInt(variantId)
        }]
    };

    // apply subscription plan if the subscribe toggle is checked
    const subscribeCheck = item.querySelector('.miniCartRecommendationsSwiperItemSubscribeCheck');
    if (subscribeCheck && subscribeCheck.checked) {
        formData.items[0].selling_plan = parseInt(item.dataset.subPlanId);
    }

    await addProduct(formData);
    await openCart();
}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}